import * as types from "../actions";
const initialState = {
  count: 0,
};

export default function test(state = initialState, action) {
  const response = action.payload;

  switch (action.type) {
    case types.TEST_ACTION_MANUEL:
      return { ...state, response };
    case types.TEST_ACTION_INCREMENT:
      return { ...state, count: state.count + 1 };
    case types.TEST_ACTION_DECREMENT:
      return { ...state, count: state.count - 1 };
    case types.TEST_ACTION_RESET:
      return { ...state, count: 0 };
    default:
      return state;
  }
}
